export default __webpack_public_path__ + "static/media/smedetoften-property-07.26ac7b5b.jpg";